module.exports = __webpack_public_path__ + "img/Slajd5.91add6f1.jpeg";